import styled from 'styled-components';

export const ArrowSlideWrapper = styled.div`
  position: absolute;
  top: calc(50% - 27px) !important;
  background: #fff !important;
  opacity: 0.5 !important;
  z-index: 2000;
  width: 32px;
  height: 32px;
  display: flex !important;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  cursor: pointer;
  &.control-prev {
    left: 10px !important;
    &:before {
      border-right-color: #212121 !important;
    }
  }
  &.control-next {
    right: 10px !important;
    &:before {
      border-left-color: #212121 !important;
    }
  }
`;
